import React from 'react';
import { compose } from 'ramda';
import { connect } from 'react-redux';
import { Map, is, List, OrderedMap } from 'immutable';

import styleFile from './AvailRateDetail.js';
import RichText from '@synergycms_core/components/generic/RichText';
import { Image, Button } from '@synergycms_core/components/generic/';
import Price from '@synergycms_core/components/generic/Price';
import { immutablePick, getPrepaymentText } from '../../../../utils';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import TooltipWrapper from '@synergycms_core/components/generic/TooltipWrapper';
import moment from 'moment';
import { parsePenalty } from '../../../../utils/penalties';
import { PROPERTY_MANAGEMENT_GROUP } from '../../../../config/constants';
import { withContent } from '@synergycms_core/components/providers/translateProvider';
import ModalOnSelectRate from '../../Loyalty/ModalOnSelectRate.jsx';
import {STAR_TRAVELER_CODE} from '@synergycms_app/store/customer/loyaltyActions';
import {contextualizeAppConfig} from '@synergycms_core/store/app/utils';

const DiscountTag = props => (
  <div>
    {props.discountPercent <= -5 && <RichText text={props.discountPercent + '%'} innerStyle={['availDiscount']}tabIndex={0}/>}
    {props.isBestPrice && <RichText text="_%¡mejor precio!%_" innerStyle={['availBestPrice']} translate={true}/>}
  </div>
);

const OldPrice = props =>
  props.discountPercent <= -5 && (
    <Price innerStyle={['monoHotelOldPrice', props.classes.oldPriceNoMargin]} amount={props.amount + Math.abs(props.discountAmount)} tabIndex={0} ariaLabel={'_%precio anterior%_'}/>
  );

const TaxMessage = props => (
  <RichText text={props.taxesText} innerStyle={props.classes.monoHotelTaxes} translate={false} ucFirst={true}/>
);

const TotalPrice = props => {
  return (
    <div className={[props.classes.monoContainerHotelTotal, !props.haveDiscount ? props.classes.noDiscount : ''].join(' ')}>
      <RichText text="_%precio total%_" innerStyle={props.classes.monoHotelTotalPriceText} translate={true}/>
      <Price innerStyle={props.classes.monoHotelTotalPrice}  amount={props.amount}/>
    </div>
  )
}

const PriceContent = ({ rateAvail, show_avail_price_as, showTaxes, discountPercent, classes, isLoyaltyAvail, loyaltyType, cx }) => {
  const days = rateAvail.get('days', List());
  const isValidNumber = (num) => typeof num === 'number' && !isNaN(num);

  const getPricesList = (days, key) => {
    let prices = [];
    days.forEach(day => {
      const dayPrice = day.get(key);
      if (isValidNumber(dayPrice)) {
        prices.push(dayPrice);
      }
    });
    return prices;
  };

  const pricesWithTax = getPricesList(days, 'price_tax');
  const pricesWithoutTax = getPricesList(days, 'price');

  const getMinimumPrice = (prices) => {
    if (prices.length === 0) return 0;
    return prices.reduce((min, price) => (price < min ? price : min), prices[0]);
  };

  const getTotalPrice = (prices) => prices.reduce((acc, price) => acc + price, 0);
  const getAveragePrice = (prices, count) => (count > 0 ? getTotalPrice(prices) / count : 0);

  let amount;
  let show_avail_price_as_text;

  const displayPriceAs = days.size <= 1 ? 'total' : show_avail_price_as;
  const haveDiscount = discountPercent <= -5;

  switch (displayPriceAs) {
    case 'noche':
      show_avail_price_as_text = "_%desde solo por noche%_";
      amount = showTaxes ? getMinimumPrice(pricesWithTax) : getMinimumPrice(pricesWithoutTax);
      break;
    case 'media':
      show_avail_price_as_text = "_%precio medio desde solo%_";
      const count = days.size;
      amount = getAveragePrice(showTaxes ? pricesWithTax : pricesWithoutTax, count);
      break;
    default:
      show_avail_price_as_text = "_%total habitación%_";
      amount = showTaxes ? rateAvail.get('price_tax') : rateAvail.get('price');
      break;
  }

  return (
    <div className={classes.leftInfo}>
      <Button id="td-d1-confirm-price-00" tabIndex={-1} translate={true} role={'note'}>
        <RichText text={show_avail_price_as_text} innerStyle={['roboto119b400']} translate={true} tabIndex={0}/>
        <OldPrice
          amount={showTaxes ? rateAvail.get('price_tax') : rateAvail.get('price')}
          discountPercent={discountPercent}
          discountAmount={rateAvail.get('discount_amount')}
          classes={classes}
        />
        <Price
          innerStyle={['monoHotelPriceHabi', isLoyaltyAvail && loyaltyType === STAR_TRAVELER_CODE && 'stOfferPrice', cx({ noDiscount: !haveDiscount })]}
          amount={amount} tabIndex={0} ariaLabel={'_%precio nuevo%_'}
        />
        {displayPriceAs !== 'total' ? (
          <TotalPrice classes={classes} haveDiscount={haveDiscount} amount={showTaxes ? rateAvail.get('price_tax') : rateAvail.get('price')} />
        ) : null}

      </Button>
    </div>
  );
};

const AvailRateDetail = class AvailRateDetail extends React.Component {
  static displayName = 'AvailRateDetail';

  constructor(props) {
    super(props);
    this.state = {
      modalShowed: false
    };
    this.cx = props.theme.bind();
  }

  closeModalCallback = (acceptAvail) => {
    const { config, } = this.props;
    const { showTabs, isLoyaltyAvail } = config;
    if(acceptAvail) {
      const { isSelected, roomRate} = this.props.config;
      this.props.config.selectRoomRate({isSelected, roomRate})(null);
    } else {
      if (typeof showTabs === 'function') {
        showTabs(isLoyaltyAvail ? 2 : 1)();
      }
    }
  };

  selectRoomRate = (toggleModal)=>(e)=> {
    const {isLoyaltyAvail, isSelected, roomRate} = this.props.config;
    this.props.config.selectRoomRate({isSelected, roomRate, isLoyaltyAvail, toggleModal})(e);
  }

  render() {
    const { config, theme, content} = this.props;
    const {
      rateAvail,
      roomRate,
      isSelected,
      showTaxes,
      showCityTaxes,
      checkinDate,
      stayLength,
      managementGroupID,
      currencies,
      langInfo,
      currentCurrencyCode,
      hotelCurrencyCode,
      hotel,
      isLoyaltyAvail,
      enableLoyaltyTab,
      type,
      hotelConfig
    } = config;

    const langActive = langInfo.get('code');
    const show_avail_price_as = hotelConfig.getIn(['show_avail_price_as', langActive,'translatable_value'], "total");
    //const show_avail_price_as = hotelConfig.get('show_avail_price_as',"total");

    const preDiscoundAmount = (showTaxes ? rateAvail.get('price_tax') : rateAvail.get('price')) + Math.abs(rateAvail.get('discount_amount'));
    const discountPercent = - Math.round(100 - (((showTaxes ? rateAvail.get('price_tax') : rateAvail.get('price'))/preDiscoundAmount)*100));

    const days = rateAvail.get('days', OrderedMap());
    const flexibleRate = days.first().get('flexible', false) || days.some(day => day.get('discounts').some(d => d.get('flexible', false)));
    const cityTaxValue = hotel && hotel.get('city_tax_value');

    // flexmyroom | secure cancellation
    const rateSecureCancellation = days && days?.first()?.get('secure_cancellation', false);
    const discountSecureCancellation = rateAvail && rateAvail?.get('discounts')?.some(d => d?.get('secure_cancellation', false));
    const pmsName = hotel && hotel.get('pms');
    const pms = ((rateSecureCancellation || discountSecureCancellation) && pmsName === 'FlexMyRoom') ? 'FlexMyRoom' : false;

    const cityTax = hotel && hotel.get('city_tax');
    const penaltyObj = parsePenalty(
      rateAvail.getIn(['policies', 'penalties', 0], Map),
      moment(checkinDate),
      rateAvail.get('price_tax'),
      stayLength,
      rateAvail.getIn(['policies', 'nr']) !== true,
      rateAvail.get('discounts', List()),
      days.first(),
      managementGroupID === PROPERTY_MANAGEMENT_GROUP,
      false,
      pms,
      null,
      managementGroupID
    );

    const penaltyText = penaltyObj.text;

    const { classes } = theme.styles;
    let rateName = '';

    if (pms === 'FlexMyRoom') {
      rateName = '_%cancelación segura%_';
    } else {
      if (penaltyObj.nr !== true && !penaltyObj.applyPenaltyRelease && !flexibleRate) {
        rateName = '_%cancelación gratuita%_';
      } else if (penaltyObj.nr === true && rateAvail.get('discount_percent') <= -5 && !flexibleRate) {
        rateName = '_%tarifa de oferta%_';
      } else {
        rateName = '_%condiciones especiales%_';
      }
    }

    const firstPenalty = rateAvail.getIn(['policies', 'penalties', 0]);
    let fullFreeReservation = false;
    if (firstPenalty) {
      fullFreeReservation = (firstPenalty.get('release', null) === 23976 && firstPenalty.get('type', null) === 'percentage'
        && firstPenalty.get('value', null) === 0 && firstPenalty.get('show_as', null) === 'days');
    }

    let requiredPrepayment = rateAvail.get('required_prepayment', 0) || 0;
    let requiredPrepaymentText = '';
    if (requiredPrepayment > 0 && !fullFreeReservation && !penaltyObj.nr && currencies) {
      requiredPrepaymentText = getPrepaymentText(
        requiredPrepayment,
        rateAvail.get('required_prepayment_value', ''),
        rateAvail.get('required_prepayment_type', ''),
        currencies,
        currentCurrencyCode,
        hotelCurrencyCode,
        langInfo,
        content
      );
    } else {
      requiredPrepayment = 0;
    }

    const taxesText = showTaxes ?' _%impuestos incluidos%_' : '_%impuestos no incluidos%_';
    const cityTaxText = ((showTaxes || showCityTaxes) && cityTax && (cityTaxValue ? '_%tasas no incluidas%_' : '_%tasas incluidas%_')) || '_%citytax_custom_text%_';
    const concatedTaxText = [taxesText, cityTaxText].map((tax)=>{
      return content.t(tax, false);
    }).filter(Boolean).join(' / ');

    const availButton = (toggleModal) => {
      return (<Button
        id="td-d1-confirm-price-01"
        onClick={this.selectRoomRate(toggleModal)}
        icon={theme.width <= 901 && { unicodeContent: config.langCode !== 'AR' ? 'e000' : '005C' }}
        richText={
          theme.width >= 902 && {
            ucFirst: true,
            text: '_%elige habitación%_',
            innerStyle: [classes.buttonTableView,'toggleSecondButton'],
            translate: true
          }
        }
        innerStyle={[this.cx({ selected: isSelected }), classes.selectNewAvailButton, 'toggleSecondButton']}>
        {theme.width < 902 && (
          <PriceContent
            classes={classes}
            rateAvail={rateAvail}
            showTaxes={showTaxes}
            discountPercent={discountPercent}
            isLoyaltyAvail={isLoyaltyAvail}
            loyaltyType = {type}
            show_avail_price_as={show_avail_price_as}
            cx={this.cx}
          />
        )}
      </Button>);
    }

    return (
      <div className={theme.computedInnerStyle}>
        <div className={classes.cellLeft}>
          <div className={[classes.first]}>
            <RichText text={rateName} ucFirst={true} innerStyle={['roboto14Black']} translate={true} tabIndex={0}/>
            {penaltyText && (
              <TooltipWrapper
                popover={
                  <div>
                  {/* Primero la parte de penalización */}
                  <RichText
                    translate={true}
                    text={penaltyText}
                    withVars={penaltyObj}
                    ucFirst={true}
                    innerStyle={[]}
                  />

                  {/* Luego, si toca, la parte de prepago */}
                  {requiredPrepayment !== 0 && (
                    <>
                      <br/>
                      <RichText
                        translate={true}
                        text={requiredPrepaymentText}
                        ucFirst={true}
                        innerStyle={[]}
                      />
                    </>
                  )}
                </div>
                 
              }
                popoverStyle={classes.rateTooltip}
                bottomLimit={100}
                typeTooltip={
                  'rateTooltip-' +
                  roomRate.get('ref_type') +
                  roomRate.get('room_id') +
                  roomRate.get('service_id') +
                  rateAvail.get('board_id') +
                  roomRate.get('segment')
                }
                pointerStyle={classes.tooltipPointerStyle}
                posX={'middle'}
                posY={'top'}>
                <Image unicodeContent="e143" innerStyle={['gold']}/>
              </TooltipWrapper>
            )}
          </div>
          <div className={[classes.second]}>
            <DiscountTag discountPercent={discountPercent} isBestPrice={rateAvail.get('best_price', false)}/>
          </div>
        </div>
        <div className={[classes.third]}>
          {theme.width >= 902 && (
            <PriceContent
              classes={classes}
              rateAvail={rateAvail}
              showTaxes={showTaxes}
              discountPercent={discountPercent}
              isLoyaltyAvail={isLoyaltyAvail}
              loyaltyType = {type}
              show_avail_price_as={show_avail_price_as}
              cx={this.cx}
            />
          )}

          {!isLoyaltyAvail && enableLoyaltyTab ? (
            <ModalOnSelectRate isLoyaltyAvail={isLoyaltyAvail} closeCallback={this.closeModalCallback}>
              {availButton}
            </ModalOnSelectRate>
          ) : (
            availButton()
          )}

          {theme.width >= 902 &&
            <TaxMessage
              classes={classes}
              taxesText={concatedTaxText}
            />
          }
        </div>
        {theme.width < 902 &&
          <TaxMessage
            classes={classes}
            taxesText={concatedTaxText}
          />
        }
      </div>
    );
  }
};

const mapDispatchToProps = dispatch => {
  return {};
};

const mapStateToProps = (store, ownProps) => {
  const { rateAvail, segment, roomId, boardId, serviceId, refType, occupGroupId } = ownProps;
  const hotelId = store.getIn(['customer', 'current_hotel']);
  const hotelInfo = store.getIn(['hotels', hotelId]);
  const roomRateSelected = store.getIn(['customer', 'reservation_request', 'blocks', segment - 1], Map());
  const queryParams = store.getIn(['hotels', hotelId, 'params', 'query_params']);
  const loyalty = store.getIn(["customer", "loyalty", "data", "loyalty"]);

  const roomRate = Map({
    idx: segment,
    occup_group_id: occupGroupId,
    adults: ownProps.adults,
    childs: ownProps.childs,
    babies: ownProps.babies,
    childs_info: ownProps.childsInfo,
    room_id: roomId,
    service_id: serviceId,
    board_id: boardId,
    refundable: rateAvail.get('refundable'),
    ref_type: refType,
    price: rateAvail.get('price'),
    price_tax: rateAvail.get('price_tax'),
    discount_amount: rateAvail.get('discount_amount'),
    // Compatibilitat Hab + Paquet
    room_board_price: rateAvail.get('room_board_price', rateAvail.get('price')),
    room_board_price_tax: rateAvail.get('room_board_price_tax', rateAvail.get('price_tax')),
    service_price: rateAvail.get('service_price', 0),
    required_prepayment: rateAvail.get('required_prepayment', 0),
    discounts: rateAvail.get('discounts'),
  });

  return {
    hotelConfig :contextualizeAppConfig(store, hotelId),
    hotel: hotelInfo,
    roomRate: roomRate,
    isSelected: is(roomRate, immutablePick(roomRateSelected)(...roomRate.keySeq())),
    showTaxes: hotelInfo.get('show_taxes'),
    showCityTaxes: hotelInfo.get('show_city_taxes'),
    managementGroupID: hotelInfo.get('management_group_id'),
    checkinDate: queryParams.get('date'),
    stayLength: queryParams.get('stay_length'),
    langCode: store.getIn(['customer', 'lang_info', 'code']),
    //Currencies
    currencies: store.getIn(['customer', 'currencies']),
    langInfo: store.getIn(['customer', 'lang_info']),
    currentCurrencyCode: store.getIn(['customer', 'current_currency']) || undefined,
    loyalty: store.getIn(["customer","loyalty", "data", "loyalty"]),
    hotelCurrencyCode:
      ownProps.hotelCurrencyCode ||
      store.getIn(['hotels', store.getIn(['customer', 'current_hotel']), 'currency', 'code']) || // Monohotel
      (store.get('hotels').find((v, k) => Number.isFinite(+k)) || Map()).getIn(['currency', 'code']), // Multihotel
    type: loyalty && loyalty.get("code"),

  };
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  PropertyManager([
    'rateAvail',
    'hotel',
    'selectRoomRate',
    'roomRate',
    'isSelected',
    'showTaxes',
    'showCityTaxes',
    'checkinDate',
    'stayLength',
    'langCode',
    'loyalty',
    'managementGroupID',
    'currencies',
    'langInfo',
    'currentCurrencyCode',
    'hotelCurrencyCode',
    'translate',
    'isLoyaltyAvail',
    'enableLoyaltyTab',
    'showTabs',
    'type',
    'hotelConfig'

  ]),
  withThemeJSS({ styleFile, index: 400, link: true }),
  withContent('i18n')
)(AvailRateDetail);
